import { render, staticRenderFns } from "./setting-draw.vue?vue&type=template&id=56d93fc0"
import script from "./setting-draw.vue?vue&type=script&lang=js"
export * from "./setting-draw.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Staging/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56d93fc0')) {
      api.createRecord('56d93fc0', component.options)
    } else {
      api.reload('56d93fc0', component.options)
    }
    module.hot.accept("./setting-draw.vue?vue&type=template&id=56d93fc0", function () {
      api.rerender('56d93fc0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/phase2/manager-form/components/setting-page/components/form-b/setting-draw.vue"
export default component.exports